import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from '../common/components';
import Body from './AccordionBody';


const SliderImmagini = ({ Form, SetForm, Modifica }) => (
  <Accordion
    titolo="Slider immagini"
    nearTitle="(Dimensione immagine consigliata 2880x880)"
    Body={Body}
    SetForm={SetForm}
    Form={Form}
    Modifica={Modifica}
  />
);

SliderImmagini.propTypes = {
  Form: PropTypes.shape({}).isRequired,
  Modifica: PropTypes.shape({}).isRequired,
  SetForm: PropTypes.func.isRequired,
};

SliderImmagini.displayName = 'Accordion Slider immagini';

export default SliderImmagini;
